import { useEffect, useState } from "react";
import type { MeshMapperCoverageState } from "./map/useMeshMapperCoverage";
import { COVERAGE_TYPES, coloursFor, footerLine, MESHCORE_ONLY_MESSAGE, MM_SOURCE_LINK, typesToShow, WARDRIVING_LINE, ZOOM_IN_MESSAGE } from "../lib/meshmapperCoverage";
import { CoverageSourceLink } from "./CoverageSourceLink";

// The body of the "MeshMapper coverage" legend panel (MapLegends.tsx wraps it in the folding panel): the colour key first
// (so it is the part a small panel always shows), one row per coverage type in MeshMapper's own colours and names, this
// viewer's switch, the zoom hint below zoom 9, then where the data is from, how old it is and whether the latest refresh
// worked.
export function MeshMapperLegendBody({ mm }: { mm: MeshMapperCoverageState }) {
  const [nowMs, setNowMs] = useState(() => Date.now());
  useEffect(() => {
    const t = window.setInterval(() => setNowMs(Date.now()), 30_000);
    return () => window.clearInterval(t);
  }, []);
  const meta = mm.meta;
  return (
    <div className="legend mm-legend">
      {mm.layerOn && !mm.meshcoreOnly && meta?.has_data && (
        <div className="mm-key" role="list" aria-label="Colour key">
          {typesToShow(meta.type_colours).map((type) => {
            const known = COVERAGE_TYPES.find((c) => c.type === type);
            return (
              <div className="legend-row mm-key-row" role="listitem" key={type} title={known ? `${known.name}: ${known.text}` : type}>
                <span className="legend-swatch mm-band-swatch" style={{ background: coloursFor(type, meta.type_colours).fill }} />
                <span className="mm-key-label">
                  <span className="mm-key-name">{known?.name ?? type}</span>
                  {known && <span className="mm-key-text">: {known.text}</span>}
                </span>
              </div>
            );
          })}
        </div>
      )}
      <CoverageSourceLink link={MM_SOURCE_LINK} />
      <label className="mm-legend-switch">
        <input type="checkbox" checked={mm.layerOn && !mm.meshcoreOnly} disabled={mm.meshcoreOnly} onChange={(e) => mm.setLayerOn(e.target.checked)} />
        <span>Show on the map</span>
      </label>
      {mm.meshcoreOnly && <div className="legend-row mm-zoom-hint">{MESHCORE_ONLY_MESSAGE}</div>}
      {mm.layerOn && !mm.meshcoreOnly && meta?.has_data && mm.zoomedOut && <div className="legend-row mm-zoom-hint">{ZOOM_IN_MESSAGE}</div>}
      {mm.layerOn && !mm.meshcoreOnly && meta?.has_data && (
        <div className="legend-section">
          <div className="legend-row mm-legend-updated" data-refresh={meta.refresh_status ?? "ok"}>{footerLine(meta, nowMs)}</div>
          <div className="legend-note">{WARDRIVING_LINE}</div>
        </div>
      )}
      {mm.layerOn && !mm.meshcoreOnly && !meta?.has_data && meta?.message && <div className="legend-note">{meta.message}</div>}
    </div>
  );
}
